<template>
    <div>
        <div class="spinner"></div>
    </div>
</template>

<script>
    export default {
        name: "Loader2"
    }
</script>

<style lang="scss" scoped>
.spinner {
  width: 40px;
  height: 40px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #333;

  border-radius: 100%;  
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
    opacity: 0;
  }
}
</style>